export class BookingSignalPhone {
    public HotelId!: string;
    public PMSBookingNumber!: string;
    public ReservationNumber!: string;
    public PhoneNumber!: string;
}
